module.exports = __webpack_public_path__ + "img/wenhuashengzhuce2.326cf4d8.png";